import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'policies',
    description:
      'Browse company policies by area and ask the Policy Assistant about ' +
      'one policy, one policy area, or all policies',
    icon: 'book',
    name: 'Policies',
    scenarioVariables: [],
    sessionVariables: [],
    supportsScenarios: false,
  },
  type: core.quiver.Resource.Type.App,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.App>
